import React from "react";
import ContractManager from "../components/ContractsManager/ContractManager";

const Home = () => {
    return (
        <div>
            <h1>Bienvenido al Gestor de Email-Wallet</h1>
            <ContractManager />
        </div>
    );
};

export default Home;
